import { useEffect, useState } from 'react';
import ReactQuill from 'react-quill';
import styles from './style.module.scss';

import 'react-quill/dist/quill.snow.css';
import { classNames } from '../../helpers/classNames';

interface TextEditorProps {
    onChange?: (event: string) => void;
    value?: string;
    error?: string;
    required?: boolean;
    label?: string;
    placeholder?: string;
    disabled?: boolean;
}

function TextEditor(props: TextEditorProps) {
    const {
        onChange,
        value = '',
        error,
        required = false,
        label,
        placeholder,
        disabled = false,
    } = props;
    // const myColors = [
    //   "red",
    //   "blue",
    //   "green",
    //   "purple",
    //   "#785412",
    //   "#452632",
    //   "#856325",
    //   "#963254",
    //   "#254563",
    //   "white",
    // ];
    const modules = {
        toolbar: [
            [{ header: '1' }, { header: '2' }, { font: [] }],
            [{ size: [] }],
            ['bold', 'italic', 'underline', 'strike', 'blockquote'],
            [
                { list: 'ordered' },
                { list: 'bullet' },
                { indent: '-1' },
                { indent: '+1' },
            ],
            [{ align: ['right', 'center', 'justify'] }],
            ['link', 'image', 'video'],
        ],
    };

    const formats = [
        'font',
        'size',
        'bold',
        'italic',
        'underline',
        'strike',
        'color',
        'background',
        'script',
        'header',
        'blockquote',
        'code-block',
        'indent',
        'list',
        'direction',
        'align',
        'link',
        'image',
        'video',
        'formula',
    ];

    const [content, setContent] = useState(value);
    const handleContentChange = (content: string) => {
        setContent(content);
        if (onChange) {
            onChange(content);
        }
    };

    useEffect(() => {
        setContent(value);
    }, [value]);

    return (
        <div className={styles.editorContainer}>
            {label && (
                <label className={styles.label}>
                    {label}
                    {required && <span className={styles.required}>*</span>}
                </label>
            )}
            <ReactQuill
                className={classNames([
                    styles.editor,
                    error ? styles.error : '',
                    disabled ? styles.disabled : '',
                ])}
                theme="snow"
                modules={modules}
                formats={formats}
                value={content}
                onChange={handleContentChange}
                placeholder={placeholder}
                readOnly={disabled}
            />
            {error && <span className={styles.errorMessage}>{error}</span>}
        </div>
    );
}

export default TextEditor;
